import { _deserializable } from '../_deserializable';

export class UsersRequest extends _deserializable {

  public status: number;

}
